"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import { Menu, X, Home, BookOpen, Info, Phone, LogIn, UserPlus } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { usePathname } from "next/navigation"
import { ThemeToggle } from "@/components/theme-toggle"
import Image from "next/image"

const navItems = [
  { title: "Home", href: "/", icon: Home },
  { title: "Articles", href: "/articles", icon: BookOpen },
  { title: "About Us", href: "/about", icon: Info },
  { title: "Contact", href: "/contact", icon: Phone },
]

export function MobileNav() {
  const [open, setOpen] = useState(false)
  const pathname = usePathname()
  const isLandingPage = pathname === "/"

  // Close sheet on path change
  useEffect(() => {
    setOpen(false)
  }, [pathname])

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden h-10 w-10 rounded-full">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle Menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full max-w-[280px] p-0 flex flex-col">
        <div className="border-b border-border/10 p-4 flex items-center">
          <Link href="/" className="flex items-center gap-2" onClick={() => setOpen(false)}>
            <Image 
              src="/images/white_icon_transparent_background (1).webp"
              alt="Brainpercent Logo"
              width={28} 
              height={28}
              className="h-7 w-7 object-contain" 
            />
            <span className="text-lg font-bold">Brainpercent</span>
          </Link>
          <Button variant="ghost" size="icon" className="ml-auto h-8 w-8 rounded-full" onClick={() => setOpen(false)}>
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </Button>
        </div>
        
        <div className="px-2 py-4 flex-grow overflow-y-auto">
          <nav className="space-y-1">
            {navItems.map((item) => {
              const isActive = pathname === item.href
              return (
                <Link
                  key={item.title}
                  href={isLandingPage && item.href.startsWith("/#") ? item.href : item.href.replace("/#", "/")}
                  className={`flex items-center rounded-lg px-3 py-2.5 text-base font-medium transition-colors ${
                    isActive ? "bg-primary/10 text-primary" : "text-foreground/80 hover:bg-accent hover:text-accent-foreground"
                  }`}
                  onClick={() => setOpen(false)}
                >
                  <item.icon className={`mr-3 h-5 w-5 ${isActive ? "text-primary" : "text-foreground/60"}`} />
                  {item.title}
                </Link>
              )
            })}
          </nav>
        </div>
        
        <div className="border-t border-border/10 p-4 space-y-2">
          <Button variant="outline" asChild className="w-full justify-start h-11 text-sm">
            <Link href="/auth/sign-in" onClick={() => setOpen(false)}>
              <LogIn className="mr-2 h-4 w-4" />
              Log In
            </Link>
          </Button>
          <Button asChild className="w-full justify-start h-11 text-sm bg-gradient-to-r from-primary to-secondary hover:from-primary/90 hover:to-secondary/90">
            <Link href="/signup" onClick={() => setOpen(false)}>
              <UserPlus className="mr-2 h-4 w-4" />
              Sign Up Free
            </Link>
          </Button>
          <div className="flex justify-end pt-3">
            <ThemeToggle />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}

